import type React from 'react'
import type { JSX, SyntheticEvent } from 'react'
import type {
  FormAlignItems,
  FormDirection,
  FormJustifyContent,
  FormWrap,
} from './Form.h'

import { FormSC } from './Form.styled'

export interface IFormProps {
  children: React.ReactNode
  width?: string
  height?: string
  direction?: FormDirection
  justifyContent?: FormJustifyContent
  alignItems?: FormAlignItems
  wrap?: FormWrap
  noValidate?: boolean
  className?: string // https://github.com/callstack/linaria/blob/master/docs/BASICS.md#overriding-styles
  style?: React.CSSProperties
  onSubmit: (e: SyntheticEvent) => void
}

export const Form = ({
  children,
  width,
  height,
  direction,
  justifyContent,
  alignItems,
  wrap,
  noValidate,
  className = '',
  style,
  onSubmit,
}: IFormProps): JSX.Element => (
  <FormSC
    /* Prefix 'block' added to prevent 'width' and 'height' from being set as an attribute */
    blockWidth={width}
    blockHeight={height}
    direction={direction}
    justifyContent={justifyContent}
    alignItems={alignItems}
    wrap={wrap}
    onSubmit={onSubmit}
    noValidate={noValidate}
    className={className}
    style={style}
  >
    {children}
  </FormSC>
)
